import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { RadioPage } from "./pages/RadioPage";
import { GuidePage } from "./pages/GuidePage";
import { SegmentPage } from "./pages/SegmentPage";
import { SsoLoginPage } from "./pages/SsoLoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/radio/app-landing/*" element={<ServerRenderedPage />} />
      <Route path="/radio/:idSlug" element={<RadioPage />} />
      <Route path="/radios/segmento/*" element={<ServerRenderedPage />} />
      <Route path="/radios/:slug" element={<SegmentPage />} />
      <Route path="/como-escutar-radio-online" element={<GuidePage />} />
      <Route path="/sso/login" element={<SsoLoginPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

/** Landing web-app é página do servidor (Jinja): navegação completa, fora da SPA. */
function ServerRenderedPage() {
  useEffect(() => {
    window.location.replace(window.location.pathname + window.location.search);
  }, []);
  return null;
}
